import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-batch-view',
  templateUrl: './batch-view.component.html',
  styleUrls: ['./batch-view.component.scss', '../../../../../../assets/sass/pages/page-users.scss'],

})
export class BatchViewComponent implements OnInit {

  batchId:any
  batchData:any
  student_list=[]
  constructor(private activatedroute:ActivatedRoute,
    public toastr: ToastrService,
    private route:Router,public apiService:ApiService) {
    this.activatedroute.paramMap.subscribe(params => { 
      this.batchId = params.get('id'); 
   })
  }
  ngOnInit(): void {
    this.getBatchById()
    this.getStudentByBatch(this.batchId)
  }
  getBatchById(){
    this.apiService.getBatchById(this.batchId).subscribe((res:any)=>{
      this.batchData=res.data
    })
  }
  getStudentByBatch(id){
    this.apiService.getEnrolmentsByBatchId(id,"").subscribe((res:any)=>{
      this.student_list = res?.data
    })
  }
}
